<script setup lang="ts">
// Define locale
const { setLocale, locale, t } = useI18n()
</script>

<template>
    <div class="language-switch">
        <button :class="{ active: locale === 'de' }" :aria-label="t('language.de')" @click="setLocale('de')">
            DE
        </button>
        |
        <button :class="{ active: locale === 'en' }" :aria-label="t('language.de')" @click="setLocale('en')">
            EN
        </button>
    </div>
</template>

<style  lang="scss">
.language-switch {
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: $font-subline;
    grid-column: 1 / span 2;
    @include subline($size1: 12, $size2: 14, $margin1: 0, $margin2: 0, $lineheight: 1);

    .page-header & {
        justify-content: flex-end;
        align-items: flex-start;
    }

    button {
        padding: 0 10px;
        display: block;
        white-space: nowrap;
        appearance: none;
        background: none;
        border: 0 none;
        cursor: pointer;
        font-family: inherit;
        font-size: inherit;
        color: inherit;

        &.active {
            font-family: $font-headline;
        }
    }
}
</style>
